<template>
  <div>
    <promoted-landlord-data-table/>
    <side-drawer>
      <template slot="formDetails">
        <create-promotion/>
      </template>
    </side-drawer>
  </div>
</template>

<script>
import PromotedLandlordDataTable from "../components/PromotedLandlordDataTable.vue"
export default {
  components: {
    "promoted-landlord-data-table": PromotedLandlordDataTable,
    "side-drawer": () => import("@/core/components/SideDrawer"),
    "create-promotion": () => import("../components/rightSideDrawer/CreatePromotionForm.vue")
  }
}
</script>

<style>

</style>